import { css } from "@compiled/react";

export const ErrorMessage = () => (
    <div
        css={css({
            display: "flex",
            justifyContent: "center",
            height: "600px",
            alignItems: "center"
        })}
    >
        <div
            role="alert"
            aria-label="Loading"
            data-testid="global-nav-user-profile-container-spinner"
        >
            ERROR
        </div>
    </div>
);
